import { FC, lazy } from 'react';
import { Route, Switch, useParams } from 'react-router-dom';
import { PageSpinner } from 'src/components/spinner-container';
import { useMultiYearAllocation } from 'src/pages/reporting/my-transactions/multi-year/allocation-to-balancing-groups/use-multi-year-allocation';
import { useCapacityManagementRoot } from 'src/pages/transport/network-points/details/availability-and-price-data/overview/use-capacity-management-root';

const DetailsPage = lazy(() => import('./details/page'));
const AddPage = lazy(() => import('./add/page'));
const EditPage = lazy(() => import('./edit/page'));
const NotFound = lazy(() => import('src/pages/errors/not-found'));

export const MultiYearAllocationToBalancingGroups: FC = () => {
  const { multiYearAllocationId } = useParams<{
    multiYearAllocationId: string;
  }>();

  const capacityManagementRoot = useCapacityManagementRoot();
  const multiYearAllocation = useMultiYearAllocation({
    capacityManagementRoot,
    multiYearAllocationId,
  });

  if (!capacityManagementRoot.response || !multiYearAllocation.response)
    return <PageSpinner />;

  return (
    <Switch>
      <Route
        exact
        path="/reporting/my-transactions/multi-year/:multiYearAllocationId/allocation-to-balancing-groups/:balancingGroupAllocationId/edit"
      >
        <EditPage
          multiYearAllocation={multiYearAllocation}
          capacityManagementRoot={capacityManagementRoot}
        />
      </Route>

      <Route
        exact
        path="/reporting/my-transactions/multi-year/:multiYearAllocationId/allocation-to-balancing-groups/add"
      >
        <AddPage
          multiYearAllocation={multiYearAllocation}
          capacityManagementRoot={capacityManagementRoot}
        />
      </Route>

      <Route
        exact
        path="/reporting/my-transactions/multi-year/:multiYearAllocationId/allocation-to-balancing-groups"
      >
        <DetailsPage
          multiYearAllocation={multiYearAllocation}
          capacityManagementRoot={capacityManagementRoot}
        />
      </Route>

      <NotFound />
    </Switch>
  );
};
